export default "__VITE_ASSET__98e92739__"